import { SxProps, Theme } from '@mui/material';
import { PropsWithChildren } from 'react';

import { Card, CardVariant } from '@/components/layout/Card/Card';

export function GiftCard({
  children,
  sx,
  variant = 'transparent',
}: PropsWithChildren<{
  sx?: SxProps<Theme>;
  variant?: CardVariant;
}>) {
  return (
    <Card
      sx={{
        height: '100%',
        flexGrow: 1,
        ...sx,
      }}
      variant={variant || 'transparent'}
    >
      {children}
    </Card>
  );
}
